module.exports = __webpack_public_path__ + "img/16e95c1283604f369d65a41cf3ea9a94.345d9e2b.png";